<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Promo2019Pact from './Promo2019_Pact.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsPromo2019Pact = Promo2019Pact.data().items

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-12-02',
        major: [ 'りんかコレクション', 'めるコレクション', '共通' ],
        excepts: [
        ],
        items: [

          // [NOTE] JR2
          // ================================================================================

          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-04',
            rare        : 'JR',
            name        : 'やさしさのピンクジュエルドレス',
            imgUrl      : '/images/items/JR2-04.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-05',
            rare        : 'JR',
            name        : 'やさしさのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR2-05.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-06',
            rare        : 'JR',
            name        : 'やさしさのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-06.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-07',
            rare        : 'JR',
            name        : 'やさしさのイエロージュエルドレス',
            imgUrl      : '/images/items/JR2-07.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-08',
            rare        : 'JR',
            name        : 'やさしさのイエロージュエルシューズ',
            imgUrl      : '/images/items/JR2-08.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-09',
            rare        : 'JR',
            name        : 'やさしさのイエロージュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-09.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-01',
            rare        : 'JR',
            name        : 'やさしさのブルージュエルドレス',
            imgUrl      : '/images/items/JR2-01.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-02',
            rare        : 'JR',
            name        : 'やさしさのブルージュエルシューズ',
            imgUrl      : '/images/items/JR2-02.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-03',
            rare        : 'JR',
            name        : 'やさしさのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-03.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-10',
            rare        : 'JR',
            name        : 'やさしさのゴールドジュエルドレス',
            imgUrl      : '/images/items/JR2-10.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-11',
            rare        : 'JR',
            name        : 'やさしさのゴールドジュエルシューズ',
            imgUrl      : '/images/items/JR2-11.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-12',
            rare        : 'JR',
            name        : 'やさしさのゴールドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-12.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-13',
            rare        : 'JR',
            name        : 'やさしさのブラックジュエルドレス',
            imgUrl      : '/images/items/JR2-13.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-14',
            rare        : 'JR',
            name        : 'やさしさのブラックジュエルシューズ',
            imgUrl      : '/images/items/JR2-14.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-15',
            rare        : 'JR',
            name        : 'やさしさのブラックジュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-15.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-16',
            rare        : 'JR',
            name        : 'やさしさのレッドジュエルドレス',
            imgUrl      : '/images/items/JR2-16.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-17',
            rare        : 'JR',
            name        : 'やさしさのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR2-17.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-18',
            rare        : 'JR',
            name        : 'やさしさのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-18.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-19',
            rare        : 'JR',
            name        : 'やさしさのグリーンジュエルドレス',
            imgUrl      : '/images/items/JR2-19.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-20',
            rare        : 'JR',
            name        : 'やさしさのグリーンジュエルシューズ',
            imgUrl      : '/images/items/JR2-20.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-21',
            rare        : 'JR',
            name        : 'やさしさのグリーンジュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-21.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-22',
            rare        : 'JR',
            name        : 'やさしさのパープルジュエルドレス',
            imgUrl      : '/images/items/JR2-22.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-23',
            rare        : 'JR',
            name        : 'やさしさのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR2-23.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-24',
            rare        : 'JR',
            name        : 'やさしさのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-24.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-25',
            rare        : 'JR',
            name        : 'やさしさのホワイトジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR2-25',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-26',
            rare        : 'JR',
            name        : 'やさしさのホワイトジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR2-26',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-27',
            rare        : 'JR',
            name        : 'やさしさのホワイトジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR2-27',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-28',
            rare        : 'JR',
            name        : 'やさしさのレインボージュエルドレス',
            imgUrl      : '/images/items/JR2-28.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'SA',
            type        : 'CO',
            point       : 1500,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-29',
            rare        : 'JR',
            name        : 'やさしさのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR2-29.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'JR2-30',
            rare        : 'JR',
            name        : 'やさしさのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR2-30.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'JR',
          }),


          // [NOTE] JR3
          // ================================================================================

          item({
            collection  : 'めるコレクション',
            id          : 'JR3-04',
            rare        : 'JR',
            name        : 'ちしきのピンクジュエルドレス',
            imgUrl      : '/images/items/JR3-04.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-05',
            rare        : 'JR',
            name        : 'ちしきのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR3-05.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-06',
            rare        : 'JR',
            name        : 'ちしきのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-06.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-07',
            rare        : 'JR',
            name        : 'ちしきのイエロージュエルドレス',
            imgUrl      : '/images/items/JR3-07.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-08',
            rare        : 'JR',
            name        : 'ちしきのイエロージュエルシューズ',
            imgUrl      : '/images/items/JR3-08.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-09',
            rare        : 'JR',
            name        : 'ちしきのイエロージュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-09.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-10',
            rare        : 'JR',
            name        : 'ちしきのブルージュエルドレス',
            imgUrl      : '/images/items/JR3-10.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-11',
            rare        : 'JR',
            name        : 'ちしきのブルージュエルシューズ',
            imgUrl      : '/images/items/JR3-11.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-12',
            rare        : 'JR',
            name        : 'ちしきのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-12.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-13',
            rare        : 'JR',
            name        : 'ちしきのゴールドジュエルドレス',
            imgUrl      : '/images/items/JR3-13.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-14',
            rare        : 'JR',
            name        : 'ちしきのゴールドジュエルシューズ',
            imgUrl      : '/images/items/JR3-14.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-15',
            rare        : 'JR',
            name        : 'ちしきのゴールドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-15.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-16',
            rare        : 'JR',
            name        : 'ちしきのブラックジュエルドレス',
            imgUrl      : '/images/items/JR3-16.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-17',
            rare        : 'JR',
            name        : 'ちしきのブラックジュエルシューズ',
            imgUrl      : '/images/items/JR3-17.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-18',
            rare        : 'JR',
            name        : 'ちしきのブラックジュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-18.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-19',
            rare        : 'JR',
            name        : 'ちしきのレッドジュエルドレス',
            imgUrl      : '/images/items/JR3-19.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-20',
            rare        : 'JR',
            name        : 'ちしきのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR3-20.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-21',
            rare        : 'JR',
            name        : 'ちしきのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-21.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-22',
            rare        : 'JR',
            name        : 'ちしきのグリーンジュエルドレス',
            imgUrl      : '/images/items/JR3-22.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-23',
            rare        : 'JR',
            name        : 'ちしきのグリーンジュエルシューズ',
            imgUrl      : '/images/items/JR3-23.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-24',
            rare        : 'JR',
            name        : 'ちしきのグリーンジュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-24.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-01',
            rare        : 'JR',
            name        : 'ちしきのパープルジュエルドレス',
            imgUrl      : '/images/items/JR3-01.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-02',
            rare        : 'JR',
            name        : 'ちしきのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR3-02.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-03',
            rare        : 'JR',
            name        : 'ちしきのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-03.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-25',
            rare        : 'JR',
            name        : 'ちしきのホワイトジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR3-25',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-26',
            rare        : 'JR',
            name        : 'ちしきのホワイトジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR3-26',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-27',
            rare        : 'JR',
            name        : 'ちしきのホワイトジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR3-27',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'JR3-28',
            rare        : 'JR',
            name        : 'ちしきのレインボージュエルドレス',
            imgUrl      : '/images/items/JR3-28.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-29',
            rare        : 'JR',
            name        : 'ちしきのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR3-29.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'JR3-30',
            rare        : 'JR',
            name        : 'ちしきのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR3-30.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'JR',
          }),


          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'りんかコレクション',
            id          : 'J2-01',
            rare        : 'HR',
            name        : 'アラビアンナイトサンセットワンピ',
            imgUrl      : '/images/items/J2-01.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-02',
            rare        : 'HR',
            name        : 'アラビアンナイトサンセットシューズ',
            imgUrl      : '/images/items/J2-02.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-03',
            rare        : 'HR',
            name        : 'アラビアンナイトサンセットヘアアクセ',
            imgUrl      : '/images/items/J2-03.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'J2-61',
            rare        : 'HR',
            name        : 'アラビアンナイトマゼンタワンピ',
            imgUrl      : '/images/items/J2-61.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-62',
            rare        : 'HR',
            name        : 'アラビアンナイトマゼンタシューズ',
            imgUrl      : '/images/items/J2-62.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-63',
            rare        : 'HR',
            name        : 'アラビアンナイトマゼンタヘアアクセ',
            imgUrl      : '/images/items/J2-63.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'りんかコレクション',
            id          : 'J2-04',
            rare        : 'PR',
            name        : 'ミラクルアイドルクールトップス',
            imgUrl      : '/images/items/J2-04.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-05',
            rare        : 'PR',
            name        : 'ミラクルアイドルクールスカート',
            imgUrl      : '/images/items/J2-05.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-06',
            rare        : 'PR',
            name        : 'ミラクルアイドルクールシューズ',
            imgUrl      : '/images/items/J2-06.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-07',
            rare        : 'PR',
            name        : 'ミラクルアイドルクールヘアアクセ',
            imgUrl      : '/images/items/J2-07.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'J2-08',
            rare        : 'PR',
            name        : 'サーカスヒロイントップス',
            imgUrl      : '/images/items/J2-08.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-09',
            rare        : 'PR',
            name        : 'サーカスヒロインスカート',
            imgUrl      : '/images/items/J2-09.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-10',
            rare        : 'PR',
            name        : 'サーカスヒロインシューズ',
            imgUrl      : '/images/items/J2-10.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-11',
            rare        : 'PR',
            name        : 'サーカスヒロインヘアアクセ',
            imgUrl      : '/images/items/J2-11.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'J2-64',
            rare        : 'PR',
            name        : 'サーカスリングマスタートップス',
            imgUrl      : '/images/items/J2-64.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-65',
            rare        : 'PR',
            name        : 'サーカスリングマスタースカート',
            imgUrl      : '/images/items/J2-65.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-66',
            rare        : 'PR',
            name        : 'サーカスリングマスターシューズ',
            imgUrl      : '/images/items/J2-66.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-67',
            rare        : 'PR',
            name        : 'サーカスリングマスターヘアアクセ',
            imgUrl      : '/images/items/J2-67.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'J2-68',
            rare        : 'PR',
            name        : 'サーカスピエロトップス',
            imgUrl      : '/images/items/J2-68.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-69',
            rare        : 'PR',
            name        : 'サーカスピエロパンツ',
            imgUrl      : '/images/items/J2-69.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-70',
            rare        : 'PR',
            name        : 'サーカスピエロシューズ',
            imgUrl      : '/images/items/J2-70.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-71',
            rare        : 'PR',
            name        : 'サーカスピエロヘアアクセ',
            imgUrl      : '/images/items/J2-71.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'りんかコレクション',
            id          : 'J2-12',
            rare        : 'SR',
            name        : 'もりのおんがくたいフォレストトップス',
            imgUrl      : '/images/items/J2-12.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-13',
            rare        : 'SR',
            name        : 'もりのおんがくたいフォレストスカート',
            imgUrl      : '/images/items/J2-13.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-14',
            rare        : 'SR',
            name        : 'もりのおんがくたいフォレストシューズ',
            imgUrl      : '/images/items/J2-14.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-15',
            rare        : 'SR',
            name        : 'もりのおんがくたいフォレストヘアアクセ',
            imgUrl      : '/images/items/J2-15.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'J2-16',
            rare        : 'SR',
            name        : 'ゆうびんやさんあおぞらワンピ',
            imgUrl      : '/images/items/J2-16.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-17',
            rare        : 'SR',
            name        : 'ゆうびんやさんあおぞらシューズ',
            imgUrl      : '/images/items/J2-17.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-18',
            rare        : 'SR',
            name        : 'ゆうびんやさんあおぞらヘアアクセ',
            imgUrl      : '/images/items/J2-18.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'J2-19',
            rare        : 'SR',
            name        : 'ロータスチャイナブルーブラウス',
            imgUrl      : '/images/items/J2-19.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-20',
            rare        : 'SR',
            name        : 'ロータスチャイナブルースカート',
            imgUrl      : '/images/items/J2-20.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-21',
            rare        : 'SR',
            name        : 'ロータスチャイナブルーパンプス',
            imgUrl      : '/images/items/J2-21.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-22',
            rare        : 'SR',
            name        : 'ロータスチャイナブルーヘアアクセ',
            imgUrl      : '/images/items/J2-22.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'J2-72',
            rare        : 'SR',
            name        : 'もりのおんがくたいメープルトップス',
            imgUrl      : '/images/items/J2-72.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-73',
            rare        : 'SR',
            name        : 'もりのおんがくたいメープルスカート',
            imgUrl      : '/images/items/J2-73.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-74',
            rare        : 'SR',
            name        : 'もりのおんがくたいメープルシューズ',
            imgUrl      : '/images/items/J2-74.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-75',
            rare        : 'SR',
            name        : 'もりのおんがくたいメープルヘアアクセ',
            imgUrl      : '/images/items/J2-75.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'J2-76',
            rare        : 'SR',
            name        : 'ゆうびんやさんぽかぽかワンピ',
            imgUrl      : '/images/items/J2-76.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-77',
            rare        : 'SR',
            name        : 'ゆうびんやさんぽかぽかシューズ',
            imgUrl      : '/images/items/J2-77.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-78',
            rare        : 'SR',
            name        : 'ゆうびんやさんぽかぽかヘアアクセ',
            imgUrl      : '/images/items/J2-78.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'J2-79',
            rare        : 'SR',
            name        : 'ロータスチャイナブラックブラウス',
            imgUrl      : '/images/items/J2-79.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-80',
            rare        : 'SR',
            name        : 'ロータスチャイナブラックスカート',
            imgUrl      : '/images/items/J2-80.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-81',
            rare        : 'SR',
            name        : 'ロータスチャイナブラックパンプス',
            imgUrl      : '/images/items/J2-81.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-82',
            rare        : 'SR',
            name        : 'ロータスチャイナブラックヘアアクセ',
            imgUrl      : '/images/items/J2-82.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-21',
            rare        : 'SR',
            name        : 'サーカスヒロインピンクトップス',
            imgUrl      : '/images/items/MF-21.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-22',
            rare        : 'SR',
            name        : 'サーカスヒロインピンクスカート',
            imgUrl      : '/images/items/MF-22.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-23',
            rare        : 'SR',
            name        : 'サーカスヒロインピンクシューズ',
            imgUrl      : '/images/items/MF-23.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-24',
            rare        : 'SR',
            name        : 'サーカスヒロインピンクヘアアクセ',
            imgUrl      : '/images/items/MF-24.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),



          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'りんかコレクション',
            id          : 'J2-24',
            rare        : 'R',
            name        : 'おしとやかみずいろワンピ',
            imgUrl      : '/images/items/J2-24.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-25',
            rare        : 'R',
            name        : 'おしとやかみずいろシューズ',
            imgUrl      : '/images/items/J2-25.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-26',
            rare        : 'R',
            name        : 'おしとやかみずいろヘアアクセ',
            imgUrl      : '/images/items/J2-26.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'R',
          }),


          item({
            collection  : 'りんかコレクション',
            id          : 'J2-27',
            rare        : 'R',
            name        : 'ロック&ビートセットアップ',
            imgUrl      : '/images/items/J2-27.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-28',
            rare        : 'R',
            name        : 'ロック&ビートシューズ',
            imgUrl      : '/images/items/J2-28.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            id          : 'J2-29',
            rare        : 'R',
            name        : 'ロック&ビートサングラス',
            imgUrl      : '/images/items/J2-29.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'りんかコレクション',
            rare        : 'R',
          }),


          item({
            collection  : 'めるコレクション',
            id          : 'J2-84',
            rare        : 'R',
            name        : 'ハッピーバカンストップス',
            imgUrl      : '/images/items/J2-84.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-85',
            rare        : 'R',
            name        : 'ハッピーバカンススカート',
            imgUrl      : '/images/items/J2-85.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-86',
            rare        : 'R',
            name        : 'ハッピーバカンスシューズ',
            imgUrl      : '/images/items/J2-86.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-87',
            rare        : 'R',
            name        : 'ハッピーバカンスヘアアクセ',
            imgUrl      : '/images/items/J2-87.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J2-30',
            rare        : 'R',
            name        : 'ブルーフルールトップス',
            imgUrl      : '/images/items/J2-30.png',
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-31',
            rare        : 'R',
            name        : 'ブルーフルールスカート',
            imgUrl      : '/images/items/J2-31.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-32',
            rare        : 'R',
            name        : 'ブルーフルールシューズ',
            imgUrl      : '/images/items/J2-32.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-33',
            rare        : 'R',
            name        : 'ブルーフルールヘアアクセ',
            imgUrl      : '/images/items/J2-33.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J2-34',
            rare        : 'R',
            name        : 'おやすみひつじトップス',
            imgUrl      : '/images/items/J2-34.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-35',
            rare        : 'R',
            name        : 'おやすみひつじスカート',
            imgUrl      : '/images/items/J2-35.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-36',
            rare        : 'R',
            name        : 'おやすみひつじシューズ',
            imgUrl      : '/images/items/J2-36.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-37',
            rare        : 'R',
            name        : 'おやすみひつじヘアアクセ',
            imgUrl      : '/images/items/J2-37.png',
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J2-40',
            rare        : 'N',
            name        : 'パステルチューリップワンピ',
            imgUrl      : '/images/items/J2-40.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-41',
            rare        : 'N',
            name        : 'パステルチューリップシューズ',
            imgUrl      : '/images/items/J2-41.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-42',
            rare        : 'N',
            name        : 'パステルチューリップヘアアクセ',
            imgUrl      : '/images/items/J2-42.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'N',
          }),


          item({
            collection  : '共通',
            id          : 'J2-43',
            rare        : 'N',
            name        : 'ブルー×ブルーチェックワンピ',
            imgUrl      : '/images/items/J2-43.png',
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-44',
            rare        : 'N',
            name        : 'ブルー×ブルーチェックシューズ',
            imgUrl      : '/images/items/J2-44.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-45',
            rare        : 'N',
            name        : 'ブルー×ブルーチェックヘアアクセ',
            imgUrl      : '/images/items/J2-45.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'りんかコレクション',
            id          : 'J2-23',
            rare        : 'SR',
            name        : 'しろいもりのトランペット',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J2-23.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'めるコレクション',
            id          : 'J2-38',
            rare        : 'R',
            name        : 'キラッCHUまん',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J2-38.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-39',
            rare        : 'R',
            name        : 'カラフルアンブレラ',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J2-39.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J2-83',
            rare        : 'SR',
            name        : 'ビッグ☆パンダ',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J2-83.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ジュエルパクト
          // ================================================================================

          externalItem(itemsPromo2019Pact, 'JP-040', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-041', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-042', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-043', { collection: 'ジュエルパクト' }),



          // [NOTE] ブランドランク
          // ================================================================================

          item({
            collection  : 'ブランドランク',
            id          : 'SA-13',
            rare        : 'SR',
            name        : 'ロータスチャイナレッドブラウス',
            imgUrl      : '/images/items/SA-13.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'SA-14',
            rare        : 'SR',
            name        : 'ロータスチャイナレッドスカート',
            imgUrl      : '/images/items/SA-14.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'SA-15',
            rare        : 'SR',
            name        : 'ロータスチャイナレッドパンプス',
            imgUrl      : '/images/items/SA-15.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'SA-16',
            rare        : 'SR',
            name        : 'ロータスチャイナレッドヘアアクセ',
            imgUrl      : '/images/items/SA-16.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ブランドランク',
            id          : 'UQ-12',
            rare        : 'SR',
            name        : 'マジックレインどしゃぶりトップス',
            imgUrl      : '/images/items/UQ-12.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'UQ-13',
            rare        : 'SR',
            name        : 'マジックレインどしゃぶりパンツ',
            imgUrl      : '/images/items/UQ-13.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'UQ-14',
            rare        : 'SR',
            name        : 'マジックレインどしゃぶりシューズ',
            imgUrl      : '/images/items/UQ-14.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'UQ-15',
            rare        : 'SR',
            name        : 'マジックレインどしゃぶりヘアアクセ',
            imgUrl      : '/images/items/UQ-15.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-08',
            rare        : 'R',
            name        : 'チャイナロックワンピ',
            imgUrl      : '/images/items/PB-08.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-09',
            rare        : 'R',
            name        : 'チャイナロックブーツ',
            imgUrl      : '/images/items/PB-09.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-10',
            rare        : 'R',
            name        : 'チャイナロックヘアアクセ',
            imgUrl      : '/images/items/PB-10.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] マジックレインチャンネル
          // ================================================================================

          item({
            collection  : 'マジックレインチャンネル',
            id          : 'J2-53',
            rare        : 'SR',
            name        : 'マジックレインけろけろトップス',
            imgUrl      : '/images/items/J2-53.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジックレインチャンネル',
            id          : 'J2-54',
            rare        : 'SR',
            name        : 'マジックレインけろけろパンツ',
            imgUrl      : '/images/items/J2-54.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジックレインチャンネル',
            id          : 'J2-55',
            rare        : 'SR',
            name        : 'マジックレインけろけろシューズ',
            imgUrl      : '/images/items/J2-55.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジックレインチャンネル',
            id          : 'J2-56',
            rare        : 'SR',
            name        : 'マジックレインけろけろヘアアクセ',
            imgUrl      : '/images/items/J2-56.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'マジックレインチャンネル',
            id          : 'J2-57',
            rare        : 'SR',
            name        : 'マジックレインゆうだちトップス',
            imgUrl      : '/images/items/J2-57.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジックレインチャンネル',
            id          : 'J2-58',
            rare        : 'SR',
            name        : 'マジックレインゆうだちパンツ',
            imgUrl      : '/images/items/J2-58.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジックレインチャンネル',
            id          : 'J2-59',
            rare        : 'SR',
            name        : 'マジックレインゆうだちシューズ',
            imgUrl      : '/images/items/J2-59.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジックレインチャンネル',
            id          : 'J2-60',
            rare        : 'SR',
            name        : 'マジックレインゆうだちヘアアクセ',
            imgUrl      : '/images/items/J2-60.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] えものゆうびんやさんチャンネル
          // ================================================================================

          item({
            collection  : 'えものゆうびんやさんチャンネル',
            id          : 'J2-88',
            rare        : 'SR',
            name        : 'ゆうびんやさんてきぱきワンピ',
            imgUrl      : '/images/items/J2-88.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えものゆうびんやさんチャンネル',
            id          : 'J2-89',
            rare        : 'SR',
            name        : 'ゆうびんやさんてきぱきシューズ',
            imgUrl      : '/images/items/J2-89.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'えものゆうびんやさんチャンネル',
            id          : 'J2-90',
            rare        : 'SR',
            name        : 'ゆうびんやさんてきぱきヘアアクセ',
            imgUrl      : '/images/items/J2-90.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 名探偵コナンチャンネル
          // ================================================================================

          item({
            collection  : '名探偵コナンチャンネル',
            id          : 'J2-46',
            rare        : 'SR',
            name        : 'えどがわコナンセットアップ',
            imgUrl      : '/images/items/J2-46.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '名探偵コナンチャンネル',
            id          : 'J2-47',
            rare        : 'SR',
            name        : 'えどがわコナンシューズ',
            imgUrl      : '/images/items/J2-47.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '名探偵コナンチャンネル',
            id          : 'J2-48',
            rare        : 'SR',
            name        : 'えどがわコナンリボンヘアアクセ',
            imgUrl      : '/images/items/J2-48.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '名探偵コナンチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : '名探偵コナンチャンネル',
            id          : 'J2-49',
            rare        : 'SR',
            name        : 'かいとうキッドジャケット',
            imgUrl      : '/images/items/J2-49.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '名探偵コナンチャンネル',
            id          : 'J2-50',
            rare        : 'SR',
            name        : 'かいとうキッドパンツ',
            imgUrl      : '/images/items/J2-50.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '名探偵コナンチャンネル',
            id          : 'J2-51',
            rare        : 'SR',
            name        : 'かいとうキッドシューズ',
            imgUrl      : '/images/items/J2-51.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '名探偵コナンチャンネル',
            id          : 'J2-52',
            rare        : 'SR',
            name        : 'かいとうキッドハットヘアアクセ',
            imgUrl      : '/images/items/J2-52.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, items, itemsPasha } = this
        return _
          .chain(major)
          .map(collection => _.where(items, { collection }))
          .flatten()
          .difference(itemsPasha)
          .value()
      },

      itemsJR2 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'りんかコレクション' })
      },

      itemsJR3 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'めるコレクション' })
      },

      itemsHR () {
        return _.where(this.itemsMaJor, { rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' })
      },

      itemsBrandRank () {
        return _.where(this.itemsFiltered, { collection: 'ブランドランク' })
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsJewelPact () {
        return _.where(this.itemsFiltered, { collection: 'ジュエルパクト' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsMagicRain () {
        return _.where(this.itemsFiltered, { collection: 'マジックレインチャンネル' })
      },

      itemsEmoChan () {
        return _.where(this.itemsFiltered, { collection: 'えものゆうびんやさんチャンネル' })
      },

      itemsConan () {
        return _.where(this.itemsFiltered, { collection: '名探偵コナンチャンネル' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#edd50f" :items="itemsJR2" />
    </template>
    <template #col2>
      <ItemList title="JR ◆◆◆◆" color="#edd50f" :items="itemsJR3" />
    </template>
    <template #col3>
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>
    <template #col4>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="SR モーリー限定 ★★" color="#55b272" :items="itemsMolly" />
    </template>
    <template #col5>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>
    <template #col6>
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <ItemList title="マジックレインチャンネル" color="#c598ff" :items="itemsMagicRain" />
      <ItemList title="えものゆうびんやさんチャンネル" color="#c598ff" :items="itemsEmoChan" />
    </template>
    <template #col7>
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="名探偵コナンチャンネル" color="#c598ff" :items="itemsConan" />
      <ItemList title="ジュエルパクト" color="#a1c0fa" :items="itemsJewelPact" />
      <Status :date="date" :items="items" :showKira="true" :showHR="true" />
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (HR)
  .Page ::v-deep .Page__col:nth-child(3) .ItemList:nth-child(1) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8) {
      margin-top: $size-unit * 10;
    }
  }

  // コレクショングループ間の間隔 (PR)
  .Page ::v-deep .Page__col:nth-child(3) .ItemList:nth-child(2) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 10;
    }
  }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(4) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 10;
    }
  }

  // コレクショングループ間の間隔 (R)
  .Page ::v-deep .Page__col:nth-child(5) .ItemList:nth-child(1) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12),
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 10;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }
</style>
